import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "../catalogs.css";
import { useNavigate } from 'react-router-dom';
import { faAngleRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import { faCircleCheck, faFileLines } from '@fortawesome/free-regular-svg-icons';
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'libphonenumber-js';
import GeneralCaseCats from '../../../../components/catalog/GeneralCaseCats';
import { Modal } from 'react-bootstrap';
function GeneralCase() {
    const id = localStorage.getItem('userid');
    const userRole = localStorage.getItem('role');
    const jobSeekPhone = localStorage.getItem('userPhone');
    const permissions = JSON.parse(localStorage.getItem('permissions'));
    const toE164 = (phone) => {
        return phone.replace(/[^\d+]/g, '');
    };

    // const formattedPhone = '+1(457) 867-8684';
    const e164Phone = toE164("+1" + jobSeekPhone);
    const navigate = useNavigate();
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const [formData, setFormData] = useState({
        Q0005: '',
        Q0010: '',
        Q0060: '',
        Q0020: '',
        Q0030: '',
        Q0040: id,
        Q0050: id,
        Q0070: userRole && userRole === "job_seeker" ? e164Phone : '',
        Q0090: '',
        Q0100: [],
        Q0110: '',
        Q0120: '',

        Q0130: 'Yes',
        Q0140: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);
    const [reqList, setRequestList] = useState([]);
    const [selectedReqFor, setSelectedReqfor] = useState(null);
    const [selectedReqBy, setSelectedReqBy] = useState(null);
    const [selectedOwnGrp, setSelectedOwnGrp] = useState(null);
    const [ownGrpList, setOwnGrpList] = useState([]);
    const [selectedSubGrp, setSelectedSubGrp] = useState(null);
    const [subGrpList, setSubGrpList] = useState([]);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [caseList, setCaseList] = useState([]);
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => {
        setShowSuccess(false);
        if(permissions && permissions.manage_my_tasks === true){
            if(userRole && userRole === "job_seeker"){
                navigate("/task/raised-cases");  
            }else{
                navigate("/task/my-raised-cases");  
            }
        }else{
            navigate("/catalogs/global-services");
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest(`internal-users`);
            if (response.success) {
                const options = response.data.map((role) => ({
                    value: role.id,
                    label: role.full_name,
                }));
                setRequestList(options);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        if(formData && formData.Q0110 === "Yes"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`ownership-groups`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setOwnGrpList(options);
                }
            };
            fetchData();
        }
    }, [formData]);
    useEffect(() => {
        const param = {
            requested_for: selectedReqFor?.value
        }
        if(selectedReqFor){
            const fetchData = async () => {
                const response = await apiService.postRequest(`owned-case-submitting-group`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setSubGrpList(options);
                    setSelectedSubGrp(null);
                }
            };
            fetchData();
        }
    }, [selectedReqFor]);
    useEffect(() => {
        if(formData && formData.Q0090 === "Yes"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`intake/internal-user-cases`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.case_number,
                    }));
                    setCaseList(options);
                }
            };
            fetchData();
        }
    }, [formData]);

    useEffect(() => {
        if (!id) return;

        // Req By
        if (id && reqList.length > 0) {
            const selected = reqList.find(x => x.value === Number(id));
            selected && setSelectedReqBy(selected);
        }

        // Req For
        if (id && reqList.length > 0) {
            const selected = reqList.find(x => x.value === Number(id));
            selected && setSelectedReqfor(selected);
        }


    }, [reqList, id]);
    
    const handlePhoneChange = (value) => {
        if (value) {
            const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';
    
            const maxLength = maxPhoneLengths[country];
    
            // Strip the country code and check the actual phone number length
            const phoneWithoutCode = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
            
            if (phoneWithoutCode.length <= maxLength) {
            handleInputChange({ target: { name: "Q0070", value } });
            }
        } else {
            handleInputChange({ target: { name: "Q0070", value: '' } });
        }
    };
    const handleKeyDown2 = (event) => {
        const { key } = event;
        const currentValue = formData.Q0070 || '';
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';
    
        const maxLength = maxPhoneLengths[country];
    
        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
    
        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };

    const handleRelCase = (selectedOptions) => {
        setSelectedCaseId(selectedOptions); 
        
        const selectedValues = selectedOptions ? selectedOptions && selectedOptions.map(option => option.value) : [];
        
        setFormData((prevFormData) => ({
            ...prevFormData,
            Q0100: selectedValues,
        }));
        if (errors.Q0100) {
            setErrors({ ...errors, Q0100: '' });
        }
    };

    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const MAX_FILES = 20;
    const MAX_TOTAL_SIZE_MB = 200;
    const MAX_FILE_SIZE_MB = 10;
    const MAX_VIDEO_SIZE_MB = 200; // Special limit for video files
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'image/bmp',                                                    // .bmp
        'application/pdf',
        'text/csv',
        'text/plain',
        'text/html',                                                    // .html
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',                                     // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-powerpoint',                                // .ppt
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
        'application/zip',                                              // .zip
        'application/x-zip-compressed',                                 // .zip (alternate MIME)
        'multipart/x-zip',                                              // .zip (alternate MIME)
        'message/rfc822',                                               // .mht (alternate MIME)
        'multipart/related',                                            // .mht
        'video/mp4',
        'video/webm',
        'video/ogg',
        'audio/mpeg',                                                   // .mp3
        'audio/mp3',                                                    // .mp3 (alternate MIME)
        'audio/wav',                                                    // .wav
        'audio/wave',                                                   // .wav (alternate MIME)
        'audio/x-wav',                                                  // .wav (alternate MIME)
    ];

    const videoTypes = ['video/mp4', 'video/webm', 'video/ogg'];

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0080: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = selectedFiles.some(file => videoTypes.includes(file.type)) || files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file?.size, 0);
            const newSize = selectedFiles.reduce((acc, file) => acc + file?.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }
        
        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0080: "",
        }));
        
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                Q0080: `You can only upload up to ${MAX_FILES} files.`,
            }));
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            // Check if it's a video file
            const isVideo = videoTypes.includes(file.type);
            const maxSize = isVideo ? MAX_VIDEO_SIZE_MB : MAX_FILE_SIZE_MB;
            
            if (file.size > maxSize * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: isVideo 
                        ? `Video files must be less than ${MAX_VIDEO_SIZE_MB} MB.`
                        : `Each file must be less than ${MAX_FILE_SIZE_MB} MB.`,
                }));
                return;
            }
            
            if (!allowedTypes.includes(file.type)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Only image files (JPEG, PNG, GIF, BMP), CSV, PDF, XLS, XLSX, PPT, PPTX, MP4, WEBM, OGG, MP3, WAV, TXT, DOC, DOCX, HTML, MHT and ZIP are allowed.`,
                }));
                return;
            }
        }

        // Check total combined size of all files (skip if any video file is present)
        const hasVideo = droppedFiles.some(file => videoTypes.includes(file.type)) || 
                        files.some(file => file.file && videoTypes.includes(file.file.type));
        
        if (!hasVideo) {
            const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
            const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
            if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    Q0080: `Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`,
                }));
                return;
            }
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            Q0080: "",
        }));
        
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };

    const handleRemoveFile = (index) => {
        
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        fileInputRef.current.value = null;
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const validateForm = () => {
        const newErrors = {};

        if (!formData.Q0020) newErrors.Q0020 = "Short description is required.";
        if (formData.Q0020 && formData.Q0020.length < 3) {
            newErrors.Q0020 = "Short description must be at least 3 characters long.";
        }else if (formData.Q0020 && formData.Q0020.length > 200) {
            newErrors.Q0020 = 'Short description be less than 200 characters long.';
        }
        if (!formData.Q0030) newErrors.Q0030 = "Description is required.";
        if (formData.Q0030 && formData.Q0030.length < 3) {
            newErrors.Q0030 = "Description must be at least 3 characters long.";
        }else if (formData.Q0030 && formData.Q0030.length > 2000) {
            newErrors.Q0030 = 'Description be less than 2000 characters long.';
        }
        if(formData.Q0005 === "Yes"){
            if (!formData.Q0010) newErrors.Q0010 = "Full Name is required.";
            if (!formData.Q0060) newErrors.Q0060 = "Contact Email is required.";
        }
        if(formData.Q0005 !== "Yes"){
            if (!formData.Q0040) newErrors.Q0040 = "Requested for is required.";
            if (!formData.Q0050) newErrors.Q0050 = "Requested by is required.";
        }
        
        // if (!formData.Q0070) newErrors.Q0070 = "Contact phone is required.";

        if (!formData.Q0070) {
            newErrors.Q0070 = "Contact phone is required.";
        } else {
            const country =
                allowedCountries.find((c) =>
                    formData.Q0070.startsWith(`+${getCountryCallingCode(c)}`)
                ) || 'US';

            const maxLength = maxPhoneLengths[country];

            const phoneWithoutCode = formData.Q0070
                .replace(`+${getCountryCallingCode(country)}`, '')
                .replace(/\D/g, '');

            if (phoneWithoutCode.length < maxLength) {
                newErrors.Q0070 = `Phone number must be ${maxLength} digits.`;
            }
        }
        
        
        if (!formData.Q0090) newErrors.Q0090 = "Submitted a case for this inquiry before is required.";
        if(formData.Q0090 === "Yes"){
            if (!Array.isArray(formData.Q0100) || formData.Q0100.length === 0) {
                newErrors.Q0100 = "Case number is required.";
            }
        }
        if(userRole && userRole !== "job_seeker"){
            if (!formData.Q0005) newErrors.Q0005 = "Requester a External user is required.";
            if (!formData.Q0110) newErrors.Q0110 = "This case internal to one of your groups is required.";
            if(formData.Q0110 === "Yes"){
                if (!formData.Q0120) newErrors.Q0120 = "Ownership Group is required.";
            }
            if (!formData.Q0130) newErrors.Q0130 = "Submitting this request on behalf of one of your groups is required.";
            if(formData.Q0130 === "Yes"){
                if (!formData.Q0140) newErrors.Q0140 = "Choose the group on behalf of which you are submitting this request is required.";
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            const formDataToSend = new FormData();

            // Add file attachments
            files.forEach((file) => {
                formDataToSend.append('Q0080[]', file.file);
            });

            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null) {
                    formDataToSend.append(key, formData[key]);
                }
            }
            if(formData.Q0005 === 'Yes'){
                formDataToSend.delete('Q0040');
                formDataToSend.delete('Q0050');
            }else{
                formDataToSend.delete('Q0010');
                formDataToSend.delete('Q0060');
            }
            if(formData.Q0110 !== 'Yes'){
                formDataToSend.delete('Q0120');
            }
            if(userRole && userRole !== "job_seeker"){
                if(formData.Q0130 !== 'Yes'){
                    formDataToSend.delete('Q0140');
                }
            }else{
                formDataToSend.delete('Q0130');
                formDataToSend.delete('Q0140');
            }
            const response = await apiService.postRequest('cases/internal-intake-request', formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setErrors({});
                setErrorMessage('');
                setFiles([]);
                setShowSuccess(true);
                toast(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <GeneralCaseCats/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate(-1)}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> General Case</span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker">
                    <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                        <Grid container flexDirection="column">
                            <h3>Intake</h3>
                            <span>General Case</span>
                        </Grid>
                    </Grid>
                    <Grid size={{sm:12}} container>
                        <Grid size={{sm:12}} container alignItems="center">
                            <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                                <Grid size={{sm:12}} container alignItems="center">
                                    <form className='w-100 pt-4' onSubmit={handleSubmit} >
                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                            <Grid size={{ xs:12}} container>
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Short Description<span style={{color:"red"}}> *</span></span>
                                                    <input value={formData.Q0020} onChange={handleInputChange}
                                                        type="text"
                                                        name="Q0020"
                                                        minLength="3"
                                                        maxLength="201"
                                                    />
                                                    {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                </Grid>
                                            </Grid>
                                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                                <span>Description<span style={{color:"Red"}}> *</span></span>
                                                <textarea placeholder='Describe' minLength="3" maxLength="4001" value={formData.Q0030} onChange={handleInputChange} rows="10" name="Q0030"/>
                                                {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                            </Grid>
                                            {userRole !== "job_seeker" &&
                                            <Grid size={{xs:12}} container flexDirection="column">
                                                <span>Is the requester a External User?<span style={{color:"Red"}}> *</span></span>
                                                <div className='d-flex align-items-center main_radioregister'>
                                                    <input
                                                        className='ms-0'
                                                        // disabled={!showSubmits}
                                                        type="radio" 
                                                        name="Q0005"
                                                        value="Yes"
                                                        checked={formData.Q0005  === "Yes"} 
                                                        onChange={handleInputChange} 
                                                    />Yes
                                                    <input
                                                        className='ms-4'
                                                        // disabled={!showSubmits}
                                                        type="radio" 
                                                        name="Q0005"
                                                        value="No"
                                                        checked={formData.Q0005  === "No"} 
                                                        onChange={handleInputChange} 
                                                    />No
                                                </div>
                                                {errors.Q0005 && <p style={{color:"Red"}}>{errors.Q0005}</p>}
                                            </Grid>
                                            }
                                            {formData.Q0005  === "Yes" &&<>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Full Name<small className='red_starimpo'>*</small></span>
                                                    <input onChange={handleInputChange} name='Q0010' value={formData.Q0010 || ""} />
                                                    {errors.Q0010 && <p style={{color:"Red"}}>{errors.Q0010}</p>}
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Contact Email<small className='red_starimpo'>*</small></span>
                                                    <input onChange={handleInputChange} name='Q0060' value={formData.Q0060 || ""} />
                                                    {errors.Q0060 && <p style={{color:"Red"}}>{errors.Q0060}</p>}
                                                </Grid>
                                            </>}
                                            {formData.Q0005  !== "Yes" && <>
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Requested By<small className='red_starimpo'>*</small></span>
                                                <input disabled value={selectedReqBy?.label || ""} />
                                                {errors.Q0050 && <p style={{color:"Red"}}>{errors.Q0050}</p>}
                                            </Grid>
                                            {userRole && userRole !== "job_seeker" ?
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Requested For<small className='red_starimpo'>*</small></span>
                                                <Select
                                                    // isDisabled={!showgroupselect || !showSubmits}
                                                    className="basic-single select_withsearch"
                                                    classNamePrefix="select"
                                                    value={selectedReqFor}
                                                    defaultValue={null}
                                                    name="assignment_group_id"
                                                    options={reqList}
                                                    onChange={(selectedOption) => {
                                                        setSelectedReqfor(selectedOption);
                                                        handleInputChange({
                                                            target: {
                                                                name: "Q0040",
                                                                value: selectedOption ? selectedOption.value : ""
                                                            }
                                                        });
                                                    }}
                                                />
                                                {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                            </Grid>:
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Requested For<small className='red_starimpo'>*</small></span>
                                                <input disabled value={selectedReqFor?.label || ""} />
                                            </Grid>}
                                            </>}
                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                <span>Phone Number<small className='red_starimpo'>*</small></span>
                                                <PhoneInput
                                                    className='phone_input_imgs'
                                                    placeholder="Enter phone number"
                                                    defaultCountry="US"
                                                    countries={allowedCountries}
                                                    international={false}
                                                    limitMaxLength={true}
                                                    value={formData.Q0070 || ""}
                                                    onChange={handlePhoneChange}
                                                    onKeyDown={handleKeyDown2}
                                                    autoComplete="new-password"
                                                />
                                                {errors.Q0070 && <p style={{color:"Red"}}>{errors.Q0070}</p>}
                                            </Grid>
                                            <Grid size={{xs:12}} container flexDirection="column">
                                                <span>Attachments</span>
                                                <Grid size={{xs: 12 }} container justifyContent="space-between">
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={handleDragOver}
                                                        className='drag_uploaders align-items-center flex-column d-flex'
                                                    >
                                                        <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                                        <input
                                                            type="file"
                                                            multiple
                                                            onChange={handleFileChange}
                                                            style={{ display: 'none' }}
                                                            id="file-upload"
                                                            ref={fileInputRef} // Attach the ref here
                                                        />
                                                        <label htmlFor="file-upload">
                                                            Browse Files
                                                        </label>
                                                        <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                                    </div>
                                                    {errors.Q0080 && <p style={{color:"Red"}}>{errors.Q0080}</p>}
                                                </Grid>
                                                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                                    {files.map((file, index) => (
                                                        <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach reportincident">
                                                            <Grid container className="pinkbgattachreport" alignItems="center">
                                                                <span className='spanreport_elipse' style={{whiteSpace: "nowrap"}}>{index + 1}<span className='filenamesshow ms-3'>{file.name}</span></span>
                                                                <button type="button" onClick={(e) => handleRemoveFile(index)}>
                                                                    <FontAwesomeIcon icon={faXmark} />
                                                                </button>
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container>
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Do you currently have any other general cases associated with this inquiry?<span style={{color:"Red"}}> *</span></span>
                                                    <div className='d-flex align-items-center main_radioregister'>
                                                        <input
                                                            className='ms-0'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0090"
                                                            value="Yes"
                                                            checked={formData.Q0090  === "Yes"} 
                                                            onChange={handleInputChange} 
                                                        />Yes
                                                        <input
                                                            className='ms-4'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0090"
                                                            value="No"
                                                            checked={formData.Q0090  === "No"} 
                                                            onChange={handleInputChange} 
                                                        />No
                                                    </div>
                                                    {errors.Q0090 && <p style={{color:"Red"}}>{errors.Q0090}</p>}
                                                </Grid>
                                                {formData.Q0090  === "Yes" &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Add case number<span style={{color:"red"}}> *</span></span>
                                                    <Select
                                                        isMulti
                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                        className="basic-single select_withsearch"
                                                        classNamePrefix="select"
                                                        value={selectedCaseId}
                                                        defaultValue={null}
                                                        name="assignment_group_id"
                                                        options={caseList}
                                                        onChange={handleRelCase}
                                                    />
                                                    {errors.Q0100 && <p style={{color:"Red"}}>{errors.Q0100}</p>}
                                                </Grid>
                                                }
                                            </Grid>
                                            {userRole && userRole !== "job_seeker" &&
                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container>
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Is this case internal to one of your Groups?<span style={{color:"red"}}> *</span></span>
                                                    <div className='d-flex align-items-center main_radioregister'>
                                                        <input
                                                            className='ms-0'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0110"
                                                            value="Yes"
                                                            checked={formData.Q0110  === "Yes"} 
                                                            onChange={handleInputChange} 
                                                        />Yes
                                                        <input
                                                            className='ms-4'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0110"
                                                            value="No"
                                                            checked={formData.Q0110 === "No"} 
                                                            onChange={handleInputChange} 
                                                        />No
                                                    </div>
                                                    {errors.Q0110 && <p style={{color:"Red"}}>{errors.Q0110}</p>}
                                                </Grid>
                                                {formData.Q0110  === "Yes" &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Ownership Group<span style={{color:"red"}}> *</span></span>
                                                    <Select
                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                        className="basic-single select_withsearch"
                                                        classNamePrefix="select"
                                                        value={selectedOwnGrp}
                                                        defaultValue={null}
                                                        name="Q0120"
                                                        options={ownGrpList}
                                                        onChange={(selectedOption) => {
                                                            setSelectedOwnGrp(selectedOption);
                                                            handleInputChange({
                                                                target: {
                                                                    name: "Q0120",
                                                                    value: selectedOption ? selectedOption.value : ""
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    {errors.Q0120 && <p style={{color:"Red"}}>{errors.Q0120}</p>}
                                                </Grid>
                                                }
                                            </Grid>}
                                            {userRole && userRole !== "job_seeker" &&
                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container>
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Are you submitting this request on behalf of requested for groups?<span style={{color:"red"}}> *</span></span>
                                                    <div className='d-flex align-items-center main_radioregister'>
                                                        <input
                                                            className='ms-0'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0130"
                                                            value="Yes"
                                                            checked={formData.Q0130  === "Yes"} 
                                                            onChange={handleInputChange} 
                                                        />Yes
                                                        <input
                                                            className='ms-4'
                                                            // disabled={!showSubmits}
                                                            type="radio" 
                                                            name="Q0130"
                                                            value="No"
                                                            checked={formData.Q0130 === "No"} 
                                                            onChange={handleInputChange} 
                                                        />No
                                                    </div>
                                                    {errors.Q0130 && <p style={{color:"Red"}}>{errors.Q0130}</p>}
                                                </Grid>
                                                {formData.Q0130  === "Yes" &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Please choose the group on behalf of which you are submitting this request.<span style={{color:"red"}}> *</span></span>
                                                    <Select
                                                        // isDisabled={!showgroupselect || !showSubmits}
                                                        className="basic-single select_withsearch"
                                                        classNamePrefix="select"
                                                        value={selectedSubGrp}
                                                        defaultValue={null}
                                                        name="Q0140"
                                                        options={subGrpList}
                                                        onChange={(selectedOption) => {
                                                            setSelectedSubGrp(selectedOption);
                                                            handleInputChange({
                                                                target: {
                                                                    name: "Q0140",
                                                                    value: selectedOption ? selectedOption.value : ""
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    {errors.Q0140 && <p style={{color:"Red"}}>{errors.Q0140}</p>}
                                                </Grid>
                                                }
                                            </Grid>}
                                            {errorMessage && <div style={{ color: 'red', margin: '10px 0px',width:"100%" }}>{errorMessage}</div>}
                                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                                <button type="button" onClick={()=> navigate("/catalogs/global-services")} className='registersendbtn1'>Cancel</button>
                                                <button type="submit" className='registersendbtn2'>{submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Modal
                    show={showSuccess} 
                    onHide={handleCloseSuccess}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Successfully!</h3>
                            <small>Request submitted successfully.</small>
                            <button onClick={handleCloseSuccess}>OK</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    </div>
  )
}

export default GeneralCase
